import { render, staticRenderFns } from "./NewsListHotSubTwo.vue?vue&type=template&id=27b44126"
import script from "./NewsListHotSubTwo.vue?vue&type=script&lang=js"
export * from "./NewsListHotSubTwo.vue?vue&type=script&lang=js"
import style0 from "./NewsListHotSubTwo.vue?vue&type=style&index=0&id=27b44126&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports